"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Method = void 0;
/**
 * Standard methods for Hermes and HTTP requests.
 *
 * @enum {string}
 */
var Method;
(function (Method) {
    Method["DELETE"] = "DELETE";
    Method["GET"] = "GET";
    Method["OPTIONS"] = "OPTIONS";
    Method["PATCH"] = "PATCH";
    Method["POST"] = "POST";
    Method["PUT"] = "PUT";
    Method["TRACE"] = "TRACE";
})(Method = exports.Method || (exports.Method = {}));
//# sourceMappingURL=method.js.map